import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Fetch from 'i18next-fetch-backend'
import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { HydratedRouter } from 'react-router/dom'
import { getInitialNamespaces } from 'remix-i18next/client'
import i18n from './i18n'

import { installViewTransitionMotionGuard } from './utils/view-transition-tracker.ts'

installViewTransitionMotionGuard()

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

async function hydrate() {
	await i18next
		.use(initReactI18next)
		.use(LanguageDetector)
		.use(Fetch)
		.init({
			...i18n,
			ns: getInitialNamespaces(),
			backend: {
				loadPath: '/api/locales/{{lng}}/{{ns}}',
			},
			// Server has already resolved the locale and set <html lang="...">.
			// Reading htmlTag keeps the client in sync without a second
			// detection pass; `useChangeLanguage` in root.tsx handles updates
			// after navigation.
			detection: {
				order: ['htmlTag'],
				caches: [],
			},
		})

	startTransition(() => {
		hydrateRoot(
			document,
			<I18nextProvider i18n={i18next}>
				<HydratedRouter />
			</I18nextProvider>,
		)
	})
}

if (window.requestIdleCallback) {
	window.requestIdleCallback(hydrate)
} else {
	// Safari doesn't support requestIdleCallback
	// https://caniuse.com/requestidlecallback
	window.setTimeout(hydrate, 1)
}
